const CustomTooltip = ({
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  index,
  size,
}) => (
  <div
    {...tooltipProps}
    className="bg-slate-600 max-w-xs p-6 rounded-xl shadow-xl text-white relative"
  >
    <h3 className="font-bold text-lg mb-2 text-fuchsia-400">
      Step {index + 1} of {size}: {step.title}
    </h3>
    <div className="mb-4">{step.content}</div>
    <div className="flex justify-between items-center">
      {backProps && (
        <button {...backProps} className="text-gray-500 hover:underline">
          Back
        </button>
      )}
      <button
        {...primaryProps}
        className="bg-fuchsia-600 text-white px-2 py-1 rounded-md"
      >
        {index + 1 === size ? "Finish" : "Next"}
      </button>
    </div>
    <button
      {...closeProps}
      className="absolute top-2 right-3 text-gray-400 hover:text-gray-600"
    >
      ✕
    </button>
  </div>
);

export default CustomTooltip;
